import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "phone",
  "use": "phone-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"phone\">\n  <path fill-rule=\"evenodd\" d=\"M370.758,165a3.683,3.683,0,0,1-1.226-.21,16.857,16.857,0,0,1-10.353-10.626,3.677,3.677,0,0,1,1.266-4.052l0.788-.6a2.5,2.5,0,0,1,3.74.848l1.333,2.589a1.763,1.763,0,0,1,.193.8,1.742,1.742,0,0,1-.461,1.181l-0.277.3a0.977,0.977,0,0,0-.15,1.106,4.727,4.727,0,0,0,2.047,2.044,0.993,0.993,0,0,0,1.106-.148l0.3-.277a1.782,1.782,0,0,1,1.981-.269l2.592,1.332a2.494,2.494,0,0,1,.638,3.978l-0.9.912A3.7,3.7,0,0,1,370.758,165Zm-8.009-14.5a0.988,0.988,0,0,0-.605.2l-0.788.6a2.175,2.175,0,0,0-.75,2.4,15.349,15.349,0,0,0,9.427,9.675,2.219,2.219,0,0,0,2.276-.522l0.9-.912a1,1,0,0,0-.257-1.592l-2.592-1.331a0.269,0.269,0,0,0-.28.038l-0.3.278a2.525,2.525,0,0,1-2.808.377,6.21,6.21,0,0,1-2.693-2.69,2.481,2.481,0,0,1,.377-2.806l0.277-.3a0.243,0.243,0,0,0,.039-0.281l-1.332-2.59A1,1,0,0,0,362.749,150.5Z\" transform=\"translate(-359 -149)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/phone.svg
// module id = null
// module chunks = 